module.exports = __webpack_public_path__ + "img/bg-2.a1183040.jpg";